import React , {FC} from 'react';

const footerStyle: object = {
    position: 'fixed',
    height: '1.8em',
    width: '100%',
    fontSize: '0.45em',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#000',
    color: '#fff',
    bottom: '0px',
};

interface FooterProps {
    props: object,
}

export const Footer: FC<FooterProps> = ({props}) => {
    return (
        <div {...props} style={footerStyle}>
            © Matthew Roche {new Date().getFullYear()}
        </div>
    )
}